module.exports = {
  schema: {
    name: '收付方式',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '收付方式代碼',
        unique: true,
      },
      paymentMethod: {
        type: 'String',
        name: '收付方式',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'paymentMethod', width: 180 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '收付方式',
          rows: [
            [{ key: 'key' }],
            [{ key: 'paymentMethod' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/paymentMethods.js